import {
  RcsLegalEntityTypeSchema,
  RcsOrganizationTypeSchema,
} from "@redotech/redo-marketing-common/carrier-registration/rcs-registration-payloads";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/**
 * Length caps mirror `RcsRegistrationPayloadsSchema`. Telnyx answers an
 * over-long field with a 422 that no retry clears, so it is caught here.
 */
export const startRcsRegistration = {
  name: "startRcsRegistration" as const,
  input: z.object({
    teamId: zExt.objectId(),
    legalEntityName: z.string().trim().min(1),
    /** Nine digits, dash optional. */
    ein: z
      .string()
      .trim()
      .regex(/^(?:[0-9]{9}|[0-9]{2}-[0-9]{7})$/),
    legalEntityType: RcsLegalEntityTypeSchema,
    organizationType: RcsOrganizationTypeSchema,
    /** `EXCHANGE:SYMBOL`, required for PUBLIC_PROFIT. */
    stockSymbol: z
      .string()
      .trim()
      .regex(/^\S+:\S+$/)
      .optional(),
    contactJobTitle: z.string().trim().optional(),
    brandDisplayName: z.string().trim().max(100).optional(),
    agentDisplayName: z.string().trim().max(40).optional(),
    agentDescription: z.string().trim().min(1).max(100),
    logoUrl: z.string().trim().url(),
    heroUrl: z.string().trim().url(),
    // Three-digit hex is what a brand kit often holds, and the agent payload
    // accepts it, so rejecting it here would bounce a usable color.
    brandColor: z
      .string()
      .trim()
      .regex(/^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/),
    privacyPolicyUrl: z.string().trim().url(),
    termsAndConditionsUrl: z.string().trim().url(),
    supportEmail: z.string().trim().email(),
    companyOverview: z.string().trim().min(1).max(2000),
    optInScreenshotUrl: z.string().trim().url(),
    messageExamples: z
      .array(
        z.object({
          type: z.enum(["TRANSACTIONAL", "PROMOTIONAL"]),
          text: z.string().trim().min(1),
        }),
      )
      .optional(),
    testUrl: z.string().trim().url().optional(),
  }),
  output: z.object({
    status: z.enum(["started", "already-running", "completed", "blocked"]),
    workflowId: z.string().optional(),
    messagingAgentId: z.string().optional(),
    reason: z.string().optional(),
    detail: z.string().optional(),
    missingFields: z.array(z.string()).optional(),
  }),
};
